import { h, Component } from 'preact';

export default class VerificationCode extends Component {
    constructor(props) {
        super(props);
        this.refs = [];
        this.state = {
            verificationCodes: []
        };
    }

    componentDidMount() {
        this.refs[0].focus();
    }

    componentDidUpdate(prevProps) {
        if ( prevProps.reset !== this.props.reset && this.props.reset) {
            this.setState({ verificationCodes: []});
            this.refs[0].focus();
        }
    }

    renderInputs = number => {
        const codeInputs = [];
        for (let i = 0; i < number; i++ ) {
            codeInputs.push(
                <input type="text"
                       className={`form-control digit digit${i}`}
                       id={`digit${i}`}
                       ref={digit => this.refs[i] = digit}
                       value={this.state.verificationCodes[i]}
                       onInput={e => {this.enterCode(e, i)}}
                       onKeyDown={e => {this.onCodeDown(e, i)}}
                />
            );
            if (i === this.props.number / 2 - 1) {
                codeInputs.push(<span> - </span>)
            }
        }
        return codeInputs;
    };

    enterCode = (e, i) => {
        const verificationCodes = this.state.verificationCodes;
        if (e.target.value.length && !isNaN(e.target.value)) {
            verificationCodes[i] = e.target.value.slice(-1);
            this.setState({ verificationCodes });
            if (i < this.props.number -1) {
                this.refs[i+1].focus();
            }
            if (i === this.props.number -1 && this.state.verificationCodes.join('').length === this.props.number) {
                this.props.callback(this.state.verificationCodes.join(''));
            }
        } else {
            verificationCodes[i] = null;
            this.setState({ verificationCodes });
        }
    };

    onCodeDown = (e, i) => {
        if (e.keyCode === 8 || e.keyCode === 46) {
            if (i>0 && this.refs[i].value === '') {
                this.refs[i-1].focus();
            }
        }
    };

    render({number},{}) {
        return(
            <div className='verification-code-component unlock-code-fields clearfix'>
                {this.renderInputs(number)}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/scripts/views/tags/verification-code.js